import request from '@/utils/request2'

/**
 * 修改-新增自定义快捷键
 */
export function updateShortcutKey(data) {
  return request({
    url: '/cloud/product/operateClips/updateShortcutKey',
    method: 'post',
    data
  })
}

/**
 * 查询快捷键（带模块级缓存 + 并发去重 + TTL）
 *
 * 多个组件（AIHelper、VideoPlayer、ActionBar、FormCustom 等）都会调用此接口，
 * 通过内存缓存避免短时间内重复请求。updateShortcutKey / delShortcutKey 后
 * 需主动调 invalidateShortcutKeys() 让下次读取重新拉取。
 */
export function qryShortcutKey(query) {
  return request({
    url: '/cloud/product/operateClips/qryShortcutKey',
    method: 'get',
    params: query
  })
}

/**
 * 删除自定义快捷键
 */
export function delShortcutKey(data) {
  return request({
    url: '/cloud/product/operateClips/delShortcutKey',
    method: 'post',
    data
  })
}

// ---- 缓存层 ----
const CACHE_TTL_MS = 5 * 60 * 1000 // 5 分钟
let cache = null // { data, expireAt }
let inflight = null // 去重并发请求的 Promise<data>

/**
 * 获取当前用户的快捷键配置（带缓存）。
 * - 命中缓存直接 resolve
 * - 未命中则请求接口；并发场景下共享同一个 in-flight Promise
 */
export function getShortcutKeys() {
  const now = Date.now()
  if (cache && cache.expireAt < now) {
    cache = null
  }
  if (cache) {
    return Promise.resolve(cache.data)
  }
  if (inflight) return inflight
  inflight = qryShortcutKey()
    .then(res => {
      cache = {
        data: res.data,
        expireAt: Date.now() + CACHE_TTL_MS
      }
      return cache.data
    })
    .finally(() => {
      inflight = null
    })
  return inflight
}

/**
 * 清除缓存。在 updateShortcutKey / delShortcutKey 成功后调用，
 * 下次 getShortcutKeys 会重新请求接口。
 */
export function invalidateShortcutKeys() {
  cache = null
  inflight = null
}